import { render, staticRenderFns } from "./document-search.vue?vue&type=template&id=73d9cf59&scoped=true"
import script from "./document-search.vue?vue&type=script&lang=js"
export * from "./document-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9cf59",
  null
  
)

export default component.exports